import DefaultLayout from "../layouts/DefaultLayout";
import SortableDataTable from "../components/SortableDataTable";
import {useCallback, useEffect, useMemo, useState} from "react";
import ConfirmationModal from "./modals/ConfirmationModal";
import useTranslation from "../hooks/translations";
import CostCategoryModal from "./modals/CostCategoryModal";
import {TrendingDown} from "react-feather";
import {useApi} from "../contexts/ApiProvider";
import CostCategoryService from "../services/CostCategoryService";
import ProtectedContent from "../components/ProtectedContent";

export default function CostCategorySettingsPage() {
  const translations = useTranslation();
  const columns = [
    {
      name: translations.name,
      data_identifier: "name"
    },
    {
      name: translations.description,
      data_identifier: "description"
    },
    {
      name: translations.type,
      data_identifier: "type"
    },
  ];
  const pageTitle = translations.costCategory
  const pageSubtitle = translations.costCategoryPageSubtitle

  const api = useApi()
  const costCategoryService = useMemo(() => new CostCategoryService(api), [api]);

  const [openCostCategoryModal, setOpenCostCategoryModal] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [rows, setRows] = useState([]);

  const getData = useCallback(async () => {
    const response = await costCategoryService.getAll();
    const formatedResponse = response.body.map((row) => {
      return {
        id: row.id,
        name: row.name,
        description: row.description,
        type: row.type.name,
        typeId: row.type.id,
        order: row.order,
      }
    });
    setRows(formatedResponse);
  }, [costCategoryService])

  const reorderData = useCallback(async (data) => {
    const formatedRequest = data.map((row) => {
      return {
        id: row.id,
        order: data.indexOf(row) + 1
      }
    });
    await costCategoryService.reorder(formatedRequest);
  }, [costCategoryService])

  useEffect(() => {
    (async () => {
      await getData()
    })();
  }, [getData]);

  // datatable callbacks
  const onEditClick = async (data) => {
    setSelectedRow(data)
    setOpenCostCategoryModal(true)
  }

  const onDeleteClick = async (data) => {
    setSelectedRow(data)
    setOpenConfirmationModal(true)
  }

  const onAddClick = async () => {
    setOpenCostCategoryModal(true)
    setSelectedRow({})
  }

  const handleDragEnd = async (data) => {
    setRows(data)
    await reorderData(data)
  }

  // cost category modal callbacks
  const onModalSubmit = async (data) => {
    await getData()
    setOpenCostCategoryModal(false)
  }

  const onModalClose = async () => {
    setOpenCostCategoryModal(false)
  }

  // confirmation modal callbacks
  const onConfirmationModalSubmit = async (data) => {
    await costCategoryService.delete(data.id)
    await getData()
    setOpenConfirmationModal(false)
  }

  const onConfirmationModalClose = async () => {
    setOpenConfirmationModal(false)
  }

  return (
    <DefaultLayout icon={<TrendingDown/>}
                   title={pageTitle}
                   subtitle={pageSubtitle}>
      <ProtectedContent
        allowedRoles={["Admin"]}
        alt={<div style={{textAlign: "center", margin: 10}}>
          <h1>{translations.permissionsAlert}</h1></div>}>
        <SortableDataTable title={pageTitle}
                           columns={columns}
                           rows={rows}
                           editAction={onEditClick}
                           deleteAction={onDeleteClick}
                           addAction={onAddClick}
                           dragEndAction={handleDragEnd}/>
        {openCostCategoryModal &&
          <CostCategoryModal data={selectedRow}
                             title={pageTitle}
                             onModalSubmit={onModalSubmit}
                             onModalClose={onModalClose}
                             showModal={openCostCategoryModal}/>
        }
        {openConfirmationModal &&
          <ConfirmationModal data={selectedRow}
                             onConfirmationModalSubmit={onConfirmationModalSubmit}
                             onConfirmationModalClose={onConfirmationModalClose}
                             showModal={openConfirmationModal}/>
        }
      </ProtectedContent>
    </DefaultLayout>
  )
}
